import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import { Edit2, Trash2 } from "react-feather";
import { TaxUnit } from "../../../../../models";
import { useMainLocale } from "../../../../../context/MainLocaleContext";
import { TaxUnitDeleteModal } from "../../TaxUnitModal/TaxUnitDeleteModal";
import { TaxUnitEditModal } from "../../TaxUnitModal/TaxUnitEditModal";
import { GenericList } from "../GenericList";
import { ListRow } from "../GenericListRow";
import { TaxUnitMobileDetails } from "./TaxUnitMobileDetails";
import { DKTaxUnitMobileList } from "./DKTaxUnitMobileList";
interface TaxUnitMobileListLabels {
  numberOfDonationsLabel: string;
  sumDonationsLabel: string;
  sumTaxDeductionsLabel: string;
}
const TaxUnitMobileListStandard: React.FC<{
  taxUnits: TaxUnit[];
} & TaxUnitMobileListLabels> = t0 => {
  const $ = _c(25);
  const {
    taxUnits,
    numberOfDonationsLabel,
    sumDonationsLabel,
    sumTaxDeductionsLabel
  } = t0;
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [selectedTaxUnit, setSelectedTaxUnit] = useState(null);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [{
      label: "Navn"
    }, {
      label: "Identifikator"
    }];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const headers = t1;
  let t2;
  if ($[1] !== numberOfDonationsLabel || $[2] !== sumDonationsLabel || $[3] !== sumTaxDeductionsLabel || $[4] !== taxUnits) {
    let t3;
    if ($[6] !== numberOfDonationsLabel || $[7] !== sumDonationsLabel || $[8] !== sumTaxDeductionsLabel) {
      t3 = unit => {
        const contextOptions = [{
          label: "Endre",
          icon: <Edit2 size={16} />
        }, {
          label: "Slett",
          icon: <Trash2 size={16} />
        }];
        return {
          id: unit.id.toString(),
          defaultExpanded: false,
          cells: [{
            value: unit.name
          }, {
            value: unit.ssn
          }],
          contextOptions,
          onContextSelect: (option, element) => {
            bb3: switch (option) {
              case "Endre":
                {
                  setEditModalOpen(true);
                  setSelectedTaxUnit(element);
                  break bb3;
                }
              case "Slett":
                {
                  setSelectedTaxUnit(element);
                  setDeleteModalOpen(true);
                }
            }
          },
          details: <TaxUnitMobileDetails taxUnit={unit} numberOfDonationsLabel={numberOfDonationsLabel} sumDonationsLabel={sumDonationsLabel} sumTaxDeductionsLabel={sumTaxDeductionsLabel} />,
          element: unit
        };
      };
      $[6] = numberOfDonationsLabel;
      $[7] = sumDonationsLabel;
      $[8] = sumTaxDeductionsLabel;
      $[9] = t3;
    } else {
      t3 = $[9];
    }
    t2 = taxUnits.map(t3);
    $[1] = numberOfDonationsLabel;
    $[2] = sumDonationsLabel;
    $[3] = sumTaxDeductionsLabel;
    $[4] = taxUnits;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const rows = t2;
  let t3;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div>Det mangler informasjon for skatteenheten.</div>;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div>{t3}<div>Ta kontakt på <a href="mailto: donasjon@gieffektivt.no">donasjon@gieffektivt.no</a>.</div></div>;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  const emptyPlaceholder = t4;
  let t5;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = [30, 60];
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== rows) {
    t6 = <GenericList title="" headers={headers} rows={rows} emptyPlaceholder={emptyPlaceholder} expandable={true} proportions={t5} />;
    $[13] = rows;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== editModalOpen || $[16] !== selectedTaxUnit) {
    t7 = editModalOpen && selectedTaxUnit && <TaxUnitEditModal open={editModalOpen} initial={selectedTaxUnit} onClose={() => setEditModalOpen(false)} onSuccess={() => setEditModalOpen(false)} onFailure={_temp} />;
    $[15] = editModalOpen;
    $[16] = selectedTaxUnit;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== deleteModalOpen || $[19] !== selectedTaxUnit) {
    t8 = deleteModalOpen && selectedTaxUnit && <TaxUnitDeleteModal open={deleteModalOpen} taxUnit={selectedTaxUnit} onSuccess={success => {
      setDeleteModalOpen(false);
    }} onFailure={_temp2} onClose={() => setDeleteModalOpen(false)} />;
    $[18] = deleteModalOpen;
    $[19] = selectedTaxUnit;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== t6 || $[22] !== t7 || $[23] !== t8) {
    t9 = <>{t6}{t7}{t8}</>;
    $[21] = t6;
    $[22] = t7;
    $[23] = t8;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  return t9;
};
export const TaxUnitMobileList: React.FC<{
  taxUnits: TaxUnit[];
} & TaxUnitMobileListLabels> = t0 => {
  const $ = _c(10);
  const {
    taxUnits,
    numberOfDonationsLabel,
    sumDonationsLabel,
    sumTaxDeductionsLabel
  } = t0;
  const mainLocale = useMainLocale();
  if (mainLocale === "dk") {
    let t1;
    if ($[0] !== numberOfDonationsLabel || $[1] !== sumDonationsLabel || $[2] !== sumTaxDeductionsLabel || $[3] !== taxUnits) {
      t1 = <DKTaxUnitMobileList taxUnits={taxUnits} numberOfDonationsLabel={numberOfDonationsLabel} sumDonationsLabel={sumDonationsLabel} sumTaxDeductionsLabel={sumTaxDeductionsLabel} />;
      $[0] = numberOfDonationsLabel;
      $[1] = sumDonationsLabel;
      $[2] = sumTaxDeductionsLabel;
      $[3] = taxUnits;
      $[4] = t1;
    } else {
      t1 = $[4];
    }
    return t1;
  }
  let t1;
  if ($[5] !== numberOfDonationsLabel || $[6] !== sumDonationsLabel || $[7] !== sumTaxDeductionsLabel || $[8] !== taxUnits) {
    t1 = <TaxUnitMobileListStandard taxUnits={taxUnits} numberOfDonationsLabel={numberOfDonationsLabel} sumDonationsLabel={sumDonationsLabel} sumTaxDeductionsLabel={sumTaxDeductionsLabel} />;
    $[5] = numberOfDonationsLabel;
    $[6] = sumDonationsLabel;
    $[7] = sumTaxDeductionsLabel;
    $[8] = taxUnits;
    $[9] = t1;
  } else {
    t1 = $[9];
  }
  return t1;
};
function _temp() {}
function _temp2() {}